// test1476
(1476 && 0);
